import { TAGS_VALUES, EVENT_LEVELS, EVENT_STATUS } from '../constants';

const REPRESENTATION_FILTERS = {
  type: (val) => {
    const filters = {
      'search[status]': EVENT_STATUS.ACTIVE,
    };
    if (val === TAGS_VALUES.important) {
      filters['search[level]'] = EVENT_LEVELS.federal;
    } else if (val === TAGS_VALUES.passed) {
      filters['search[status]'] = EVENT_STATUS.CLOSED;
    }
    return filters;
  },
  region: (val) => (val && { 'search[region_id_or_null]': val.id }),
  municipality: (val) => (val && { 'search[municipality_id_or_null]': val.id }),
};

const AVAILABLE_FILTERS = {
  'search[pay_type]': null,
  'search[member_type]': null,
  'search[organization_id]': null,
  'search[requirements]': null,
  'search[start_at]': null,
  'search[end_at]': null,
  'search[directory_direction_id][]': null,
  'search[event_type][]': null,
  'search[level]': null,
  'search[name]': null,
  'search[add_distance]': null,
  'search[category_id]': null,

  type: null,
  region: null,
  municipality: null,
};

export default {
  name: 'eventFilters',
  namespaced: true,
  state: {
    filters: { ...AVAILABLE_FILTERS },
    defaults: { ...AVAILABLE_FILTERS },
  },
  getters: {
    getFilters: (state) => state.filters,
    getQuery: (state) => (Object.entries(state.filters)
      .reduce((acc, [key, value]) => {
        let queryParam = { [key]: value };
        if (REPRESENTATION_FILTERS[key]) queryParam = REPRESENTATION_FILTERS[key](value);
        return { ...acc, ...queryParam };
      }, {})),
    hasChanges: (state) => (
      Object.entries(state.filters).find(([key, value]) => {
        if (state.defaults[key]) {
          return state.defaults[key] !== value;
        }
        return value;
      })),
  },
  actions: {
    SET_FILTER({ commit }, { key, value, isDefault = false }) {
      if (key === 'region') commit('SET_FILTER', { key: 'municipality', data: { value: null, isDefault } });
      if (key === 'search[level]') commit('SET_FILTER', { key: 'type', data: { value: TAGS_VALUES.all, isDefault } });

      commit('SET_FILTER', { key, data: { value, isDefault } });
    },
    RESET_FILTERS({ commit }) {
      commit('RESET_FILTERS');
    },
  },
  mutations: {
    SET_FILTER(state, { key, data }) {
      state.filters[key] = data.value;

      if (data.isDefault) {
        state.defaults[key] = data.value;
      }
    },
    RESET_FILTERS(state) {
      Object.entries(state.filters).forEach(([key]) => {
        state.filters[key] = state.defaults[key] || null;
      });
    },

  },
};
